import { Location, ViewportScroller } from '@angular/common';
import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Link } from 'src/app/model/shared/link';
import { PageVersion } from 'src/app/model/shared/page-version';
import { SideMenu } from 'src/app/model/shared/side-menu';
import { ContentfulService } from 'src/app/service/contentful.service';
import { PageVersionService } from 'src/app/service/page-version.service';
import { ConfigService } from 'src/app/service/config.service';
import { APIReferencePageComponent } from '../../page/group/api-docs/api-reference-page/api-reference-page.component';
import { CommonTypesDatalistsPageComponent } from '../../page/group/api-docs/common-types-datalists-page/common-types-datalists-page.component';
import { FileAssetsPageComponent } from '../../page/group/api-docs/file-assets-page/file-assets-page.component';
import { FunctionalCapabilitiesDisruptionHandlingPageComponent } from '../../page/group/api-docs/functional-capabilities-disruption-handling-page/functional-capabilities-disruption-handling-page.component';
import { FunctionalCapabilitiesOfferManagementPageComponent } from '../../page/group/api-docs/functional-capabilities-offer-management-page/functional-capabilities-offer-management-page.component';
import { FunctionalCapabilitiesOrderManagementPageComponent } from '../../page/group/api-docs/functional-capabilities-order-management-page/functional-capabilities-order-management-page.component';

declare function leftSideMenu(): any;

@Component({
  selector: 'app-left-side-menu-api',
  templateUrl: './left-side-menu-api.component.html',
  styleUrls: ['./left-side-menu-api.component.scss']
})
export class LeftSideMenuApiComponent implements OnInit {
  @Input() pageTitle: string = '';
  @Input() apiName: string = '';
  @Input() subscribeUrl: string = '';
  @Input() apiTabs: string[] = [];
  @Input() apiTabsClass: string[] = [];
  @Input() tabName: string = '';
  @Input() href: string = '';
  @Input() isTabOverride: boolean = false;

  isTab: boolean = false;
  selectedIndex: number = 0;

  @ViewChild(APIReferencePageComponent)
  apiReferencePageComponent!: APIReferencePageComponent;

  @ViewChild(FileAssetsPageComponent)
  fileAssetsPageComponent!: FileAssetsPageComponent;

  @ViewChild(CommonTypesDatalistsPageComponent)
  commonTypesDatalistsPageComponent!: CommonTypesDatalistsPageComponent;

  @ViewChild(FunctionalCapabilitiesOfferManagementPageComponent)
  functionalCapabilitiesOfferManagementPageComponent!: FunctionalCapabilitiesOfferManagementPageComponent;

  @ViewChild(FunctionalCapabilitiesOrderManagementPageComponent)
  functionalCapabilitiesOrderManagementPageComponent!: FunctionalCapabilitiesOrderManagementPageComponent;

  @ViewChild(FunctionalCapabilitiesDisruptionHandlingPageComponent)
  functionalCapabilitiesDisruptionHandlingPageComponent!: FunctionalCapabilitiesDisruptionHandlingPageComponent;

  sideMenu: SideMenu = {} as SideMenu;

  categories: Link[] = [];
  linkMap = new Map();
  subCategoryMap = new Map();

  constructor(
    public configService: ConfigService,
    private location: Location,
    private scroller: ViewportScroller,
    private renderer: Renderer2,
    private contentfulService: ContentfulService,
    private pageVersionService: PageVersionService
  ) {}

  ngOnInit(): void {
    if (this.pageTitle === undefined) {
      this.pageTitle = '';
    }

    // console.log('pageTitle : ' + this.pageTitle);

    this.sideMenu.links = [];
    this.megaSideMenu();
  }

  closeNav() {
    let element: HTMLElement = document.getElementsByClassName('closebtnIAG')[0] as HTMLElement;
    element.click();
  }

  private megaSideMenu() {
    this.sideMenu.links = [];

    const query = { 'fields.name': 'Left Side Menu#API-DOCS' };
    this.contentfulService.getMenuContentWithItems(query).then((menuItems) => {
      this.sideMenu.links = menuItems[0]?.fields.jsonData;
      this.processJSONData();
      leftSideMenu();

      // console.log('isTabOverride : ', this.isTabOverride);

      if (this.isTabOverride) {
        let apiKey = [...this.linkMap.keys()].find((key) => key.includes('API'));

        if (['Offer Management', 'Order Management', 'Disruption Handling'].includes(this.apiName)) {
          apiKey = [...this.linkMap.keys()].find((key) => key.includes('Functional'));
        }

        // // console.log('apiKey : ', apiKey);
        // // console.log('linkMap : ', this.linkMap);

        let api = this.linkMap.get(apiKey).find((api: { apiName: string }) => {
          const apiNameArray = this.apiName.split('-');
          // console.log('api.apiName : ', api.apiName);
          // console.log('this.apiName : ', this.apiName);
          // console.log('apiNameArray : ', apiNameArray);
          const isSameApiName =
            api.apiName === this.apiName ||
            (apiNameArray.length > 0 && api.apiName === apiNameArray[0].trim()) ||
            // (this.apiName === 'Involuntary Changes - Reshop' && api.apiName === 'OrderReshop') ||
            (this.apiName === 'Involuntary Changes' && api.apiName === 'OrderChange');
          // console.log('condition: ', isSameApiName);
          return isSameApiName;
        });

        // console.log('api : ', api);
        // console.log('this.apiName : ', this.apiName);

        if (api) {
          if (api.apiName !== this.apiName) {
            api = api.references.find((api: { apiName: string }) => {
              return api.apiName === this.apiName;
            });
            // console.log('overriding api value : ', api);
          }
          this.apiTabs = api.apiTabs;
          this.apiTabsClass = api.apiTabsClass;
          this.selectedIndex = this.apiTabs.indexOf(this.tabName);
          // console.log('selectedIndex : ', this.selectedIndex);
          this.selectedIndex = this.selectedIndex > 0 ? this.selectedIndex : 0;
        }
        // console.log('apiTabs : ', this.apiTabs);
      }
    });
  }

  processJSONData() {
    this.categories.push(...this.sideMenu.links.filter((link) => link.category === undefined));

    // console.log(this.categories);

    this.categories.forEach((category) => {
      this.linkMap.set(
        category.title,
        this.sideMenu.links.filter((link) => link.category === category.title)
      );
    });

    // console.log(this.linkMap);

    if (this.pageTitle === undefined || this.pageTitle.length == 0) {
      this.pageTitle = this.sideMenu.links[0].pageTitle || '';
      // console.log('Setting API Docs Default Page : ' + this.pageTitle);
    }
  }

  setPageURL(value: string) {
    this.location.replaceState(value);
  }

  setPageTitle(value: string) {
    this.href = '';

    if (value && value.length > 0) {
      this.pageTitle = value;

      let pageVersion: PageVersion = {} as PageVersion;
      pageVersion.pageName = value;
      pageVersion.selectedPageVersion = '';
      // console.log('reset selection : ', pageVersion);
      this.pageVersionService.addPageVersionData(pageVersion);
    }
    // console.log('setPageTitle : ' + this.pageTitle);

    if (this.apiReferencePageComponent) {
      if (this.pageTitle.includes('Overview')) {
        this.apiReferencePageComponent.ngOnInitWithPageTitleForOverview(this.pageTitle);
      }
      if (this.pageTitle.includes('Request')) {
        this.apiReferencePageComponent.ngOnInitWithPageTitleForRequest(this.pageTitle);
      }
      if (this.pageTitle.includes('Response')) {
        this.apiReferencePageComponent.ngOnInitWithPageTitleForResponse(this.pageTitle);
      }
    }

    if (this.fileAssetsPageComponent) {
      this.fileAssetsPageComponent.ngOnInitWithPageTitle(this.pageTitle);
    }

    if (this.commonTypesDatalistsPageComponent) {
      this.commonTypesDatalistsPageComponent.ngOnInitWithPageTitle(this.pageTitle);
    }

    if (this.functionalCapabilitiesOfferManagementPageComponent) {
      this.functionalCapabilitiesOfferManagementPageComponent.ngOnInitWithPageTitle(this.pageTitle);
    }

    if (this.functionalCapabilitiesOrderManagementPageComponent) {
      this.functionalCapabilitiesOrderManagementPageComponent.ngOnInitWithPageTitle(this.pageTitle);
    }

    if (this.functionalCapabilitiesDisruptionHandlingPageComponent) {
      this.functionalCapabilitiesDisruptionHandlingPageComponent.ngOnInitWithPageTitle(this.pageTitle);
    }
  }

  setAPIName(value: string) {
    if (value && value.length > 0) {
      this.apiName = value;
    }
    // console.log('setAPIName : ' + this.apiName);
  }

  setAPITabs(value: string[]) {
    if (value && value.length > 0) {
      this.apiTabs = value;
    }
    // console.log('setAPITabs : ' + this.apiTabs);
  }

  setAPITabsClass(value: string[]) {
    if (value && value.length > 0) {
      this.apiTabsClass = value;
    }
    // console.log('setAPITabsClass : ' + this.apiTabsClass);
  }

  setIsTab(value: boolean) {
    if (value === undefined) {
      this.isTab = false;
    } else {
      this.isTab = value;
    }
    // console.log('setIsTab : ' + this.isTab);
  }

  scrollToHref(value: string) {
    if (value && value.length > 0) {
      this.href = value;
      this.scroller.scrollToAnchor(value);
    }
    // console.log('scrollToHref : ' + value);
  }

  scrollToClass(value: string) {
    if (value && value.length > 0) {
      this.href = value;
      try {
        this.renderer.selectRootElement('.' + this.href).scrollIntoView();
      } catch (e) {
        this.handleFlightShopping(value);
      }
    }
  }

  private handleFlightShopping(value: string) {
    if (value === 'FlightShopping') {
      this.setPageTitle('Offer Management Start');
      this.setAPIName('Offer Management');
      this.setAPITabs(['Start', 'Fare Rules', 'New Branded Fares', 'Offer Storage']);
      this.setAPITabsClass(['', '', '', '']);
      this.setIsTab(false);
      this.closeNav();
    }
    setTimeout(() => {
      this.renderer.selectRootElement('.' + value).scrollIntoView();
    }, 2000);
  }
}
